<modal-layout-right modalTitle="Finance">
    <div modalBody>
        <p sizeClass="SM:s1, XL:h4"
           *iCms="'title' of content; skipEmpty: true"></p>
        <p class="p1 p-t-2"
           *iCms="'description' of content; skipEmpty: true"></p>
        <p class="p-t-2 p-b-8 p-b-7-s p-b-7-m"
           sizeClass="SM:s2, XL:s1"
           *iCms="'finance_tile' of content; skipEmpty: true"></p>
        <ul>
            @for (item of content?.elements; track item; let even = $even; let index = $index) {
            <li class="flex flex-justify-between p-a-2"
                [class.bg-col-5]="even">
                <span class="s2"
                      *iCms="'title' of item"></span>
                <span class="p2"
                      *iCms="'value' of item"></span>
            </li>
            }
        </ul>
        <p class="c1 p-t-8 col-12"
           *iCms="'finance_footer' of content; skipEmpty: true"></p>
    </div>
</modal-layout-right>
